import { useState } from "react";
import { Save, Loader2 } from "lucide-react";
import { api, describeAxiosError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { KPIS } from "./helpers";

export const AnnualTargetForm = ({ employeeId, year, data, onSaved, onCancel }) => {
  const [values, setValues] = useState(() => Object.fromEntries(KPIS.map((k) => [k, data.annual_targets?.[`${k}_target`] ?? data.ytd[k].monthly_target_total])));
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const save = async (event) => {
    event.preventDefault(); if (busy) return;
    setBusy(true); setError("");
    try {
      await api.put(`/performance/annual-targets/${employeeId}`, {
        financial_year: year, ...Object.fromEntries(KPIS.map((k) => [`${k}_target`, Number(values[k])])),
      });
      onSaved();
    } catch (e) { setError(describeAxiosError(e)); }
    finally { setBusy(false); }
  };
  return <form onSubmit={save} className="border-y border-stone-200 py-5 space-y-4" data-testid="annual-target-form">
    <fieldset disabled={busy} className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid="annual-target-fields">
      {KPIS.map((k) => <label key={k} className="text-xs font-medium capitalize min-w-0">Annual {k} target ₹
        <Input required type="number" min="0" max="1000000000000" step="1" className="mt-2 bg-white" value={values[k]} onChange={(e) => setValues({ ...values, [k]: e.target.value })} data-testid={`annual-${k}-target`} />
      </label>)}
    </fieldset>
    {error && <p role="alert" className="text-sm text-red-700" data-testid="annual-target-error">{error}</p>}
    <div className="flex gap-2 justify-end">
      <Button type="button" variant="outline" disabled={busy} onClick={onCancel} data-testid="annual-target-cancel">Cancel</Button>
      <Button type="submit" disabled={busy} data-testid="annual-target-save">{busy ? <Loader2 className="animate-spin" /> : <Save />}Save annual targets</Button>
    </div>
  </form>;
};